import { createSelector } from 'reselect'

const isCombinedReturnTicket = false

const getCurrencyCode = (state) => state.user.currency
const getCurrencyTypes = (state) => state.user.currencyTypes
const getFeaturedCurrencies = (state) => state.user.featuredCurrencies
const getLanguageCode = (state) => state.user.languageCode
const getLastTicketSearchTimestamp = (state) => state.user.lastTicketSearchTimestamp

const getCurrencySelectData = createSelector(
  [getCurrencyTypes, getCurrencyCode],
  (currencyTypes, currencyCode) => {
    if (Object.keys(currencyTypes).length === 0) {
      return [{
        label: currencyCode,
        longLabel: currencyCode,
        data: currencyCode,
      }]
    }

    const arr = Object.keys(currencyTypes).map((key) => currencyTypes[key])
    const selectData = arr.map((currency) => ({
      label: currency.id,
      longLabel: currency.label,
      data: currency.id,
    }))

    const alphabetizedSelectData = selectData.sort((a, b) => {
      if (a.longLabel < b.longLabel) return -1
      if (a.longLabel > b.longLabel) return 1
      return 0
    })

    return alphabetizedSelectData
  }
)

const getSelectedCurrencyIndex = createSelector(
  [getCurrencyCode, getCurrencySelectData],
  (currencyCode, selectData) => {
    let selectedIndex = null
    for (let i = 0; i < selectData.length; i++) {
      if (selectData[i].data.toLowerCase() === currencyCode.toLowerCase()) {
        selectedIndex = i
        break
      }
    }
    return selectedIndex
  }
)

export {
  getSelectedCurrencyIndex,
  getCurrencyTypes,
  getCurrencySelectData,
  getCurrencyCode,
  getFeaturedCurrencies,
  isCombinedReturnTicket,
  getLanguageCode,
  getLastTicketSearchTimestamp,
}
